import {httpClient} from "../../shared/shared-services/httpClient";
import {environment} from "@/environment";

const URL = `${environment.ecommerceApiBaseUrl}subProductTags`;

export default {
  store(subProductTag) {
    return httpClient.post(URL, subProductTag)
      .then(res => res.data)
      .catch(error => console.log(error));
  },
  delete(ids) {
    return httpClient.delete(`${URL}/${ids}`)
      .then(res => res.data)
      .catch(error => console.log(error));
  }
};
